import { render, staticRenderFns } from "./selectGoods.vue?vue&type=template&id=e6a037c2&scoped=true&lang=html&"
import script from "./selectGoods.vue?vue&type=script&lang=js&"
export * from "./selectGoods.vue?vue&type=script&lang=js&"
import style0 from "./selectGoods.vue?vue&type=style&index=0&id=e6a037c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a037c2",
  null
  
)

export default component.exports